module.exports = __webpack_public_path__ + "static/media/loading.3dac53f0.gif";